import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './ProductCarousel.scss';
import { Textfit } from 'react-textfit';



const ProductCarousel = ({ products }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === products.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? products.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="product-carousel-container">
      <h2 className="carousel-title">Nuestros productos</h2>
      <div className="carousel-wrapper">
        <button className="carousel-button prev" aria-label="Previous slide">
          <FiChevronLeft />
        </button>
        <Swiper
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            pauseOnMouseLeave: true
          }}
          loop={true}
          modules={[Navigation, Pagination, EffectFade, Autoplay]}
          effect="cube"
          spaceBetween={30}
          slidesPerView={1}
          navigation={{
            prevEl: '.carousel-button.prev',
            nextEl: '.carousel-button.next',
            disabledClass: 'swiper-button-disabled'
          }}
          pagination={{
            clickable: true,
            el: '.carousel-dots',
            bulletClass: 'dot',
            bulletActiveClass: 'active',
            renderBullet: function (index, className) {
              return '<span class="' + className + '"></span>';
            }
          }}
          className="product-carousel"
        >
          {products.map((product, index) => (
            <SwiperSlide key={index}>
              <div className="product-card">
                <div className="product-image">
                  <img src={product.image} alt={product.title} />
                </div>
                <div className='product-content-container'>
                  <div className="product-title">
                    <div className='product-title-wrapper'>
                      <Textfit mode="single" min={12} max={24} >
                        {product.title}
                      </Textfit>
                    </div>

                  </div>
                  <a href={product.link} target='_blank' className="product-button">
                    Ver producto
                  </a>


                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <button className="carousel-button next" aria-label="Next slide">
          <FiChevronRight />
        </button>
      </div>
      <div className="carousel-dots"></div>
    </div>
  );
};

export default ProductCarousel;